import React from 'react';
import Cookie from 'universal-cookie';

// GRAPHQL
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

// API
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URI;
const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_BASE_URI;

const cookie = new Cookie();

const httpLink = createHttpLink({
    uri: GRAPHQL_URL
});

const authLink = setContext((_, { headers }) => {
    const token = cookie.get('authorization');
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : ''
        }
    }
});

const defaultApolloOptions = {
    watchQuery: { 
      fetchPolicy: 'network-only',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
}

const apolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions: defaultApolloOptions
});

export const withGraphQLClient = (WrappedComponent) => {
    const component = props => (
        <WrappedComponent {...props} graphQLClient={apolloClient} />
    )
    return component;
}


// API Integration
const apiClient = {
    peme : {
        PostMethod: (method, body, responseType) => {
            const token = cookie.get('authorization');
            const headers = { 'Authorization': `Bearer ${token}` }
            const object = (
                axios.post(API_URL + method, body, { responseType: responseType ? responseType : 'json', headers: headers })
                    .then(res => {
                        return res;
                    })
                    .catch(error => {
                        return error;
                    })
            );
            return object;
        },
        GetMethod: (method, body) => {
            const object = (
                axios.get(API_URL + method + body)
                    .then(res => {
                        return res;
                    })
                    .catch(error => {
                        return error
                    })
            );
            return object;
        }
    }

}

export const withApi = (WrappedComponent) => {
    const component = props => (
        <WrappedComponent {...props} api={apiClient} />
    );
    return component;
}
